var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunningWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.813,
    height: 21.362,
    viewBox: "0 0 28.813 21.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "running",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M25.96,12.747l-4.3-.308L18.81,7.7,17.388,5.327V4.67A1.292,1.292,0,0,0,15.63,3.465L11.539,5.043l.309-1.037A1.928,1.928,0,0,0,10.9,1.784L7.687.059a.5.5,0,0,0-.661.182L2.319,7.78l-.1-.058a.5.5,0,0,0-.678.183l-.009.015L.059,10.7a.5.5,0,0,0,.2.668L18.183,21.3a.5.5,0,0,0,.24.062h7.41a2.983,2.983,0,0,0,2.981-2.981V15.812A3.083,3.083,0,0,0,25.96,12.747Zm-5.343-.106-.567.189L15.6,7.05l1.143-.858ZM7.635,1.159l2.792,1.5a.936.936,0,0,1,.466,1.073l-.41,1.383L7.631,3.4,6.644,2.81ZM4.693,5.9l.254-.4L6.582,6.718A2.845,2.845,0,0,1,7.69,9.4l-.062,1.436L3.188,8.278Zm21.14,14.468H18.552L1.164,10.731l1-1.888L18.63,18.315a.5.5,0,0,0,.248.066H27.82A1.987,1.987,0,0,1,25.833,20.368Zm1.987-2.981H19.011L15.6,15.426l1.146-1.168a.5.5,0,0,0-.709-.7l-1.325,1.351-1.888-1.088,1.893-1.515a.5.5,0,0,0-.621-.776l-2.2,1.758-1.617-.93,2.454-2.045a.5.5,0,1,0-.636-.764L9.366,11.834,8.6,11.392l.08-1.907a3.815,3.815,0,0,0-1.5-3.567L5.482,4.66l.639-1,4.4,2.638a.486.486,0,0,0,.192.062c.012,0,.022,0,.034,0s.019,0,.029,0a.494.494,0,0,0,.18-.033l5.032-1.941a.3.3,0,0,1,.406.281v.546L14.6,6.559a.5.5,0,0,0-.1.7l0,0,4.968,6.458a.494.494,0,0,0,.55.168l1.4-.466,4.464.319a2.086,2.086,0,0,1,1.932,2.073Zm0,0",
    transform: "translate(-0.001 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M2.981,256H.5a.5.5,0,0,0,0,.994H2.981a.5.5,0,0,0,0-.994Zm0,0",
    transform: "translate(0 -241.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M0,309.462a.5.5,0,0,0,.5.5H6.955a.5.5,0,0,0,0-.994H.5A.5.5,0,0,0,0,309.462Zm0,0",
    transform: "translate(0 -291.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M12.42,361.934H.5a.5.5,0,1,0,0,.993H12.42a.5.5,0,0,0,0-.993Zm0,0",
    transform: "translate(0 -341.565)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunningWhite);
export default __webpack_public_path__ + "static/media/running-white.352edb502cef772c11caaf68690204d1.svg";
export { ForwardRef as ReactComponent };